import { Button } from '@app/shared/ui/button';

export const LazyLoadErrorFallback = ({ error }: { error: Error }) => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex items-center justify-center min-h-screen mx-auto max-w-[1320px]">
      <div className="flex flex-col items-center justify-center gap-4 text-center">
        <h1 className="text-font_ds_title_title_title_32 font-medium text-general_text_MII_default mb-2">
          😦 Oops! Something went wrong
        </h1>

        <p className="text-general_text_MII_secondary_i text-font_ds_title_body_body_18 max-w-md mb-6">
          Failed to load part of the application. It may have been updated. Try refreshing the page.
        </p>

        <Button
          onClick={handleReload}
          variant="primary"
          size="medium"
          className="flex items-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
          Refresh page
        </Button>

        {process.env.NODE_ENV === 'development' && (
          <details className="mt-4 max-w-md">
            <summary className="text-font_ds_title_body_body_14 text-general_text_MII_secondary_ii cursor-pointer">
              Error details (dev)
            </summary>
            <pre className="text-font_ds_title_body_body_12 text-general_text_MII_secondary_iii mt-2 p-2 bg-general_background_MIII_100_light rounded overflow-auto">
              {error.message}
            </pre>
          </details>
        )}
      </div>
    </div>
  );
};
